export var OverlayPosition;
(function (OverlayPosition) {
    OverlayPosition[OverlayPosition["Custom"] = 0] = "Custom";
    OverlayPosition[OverlayPosition["Centered"] = 1] = "Centered";
    OverlayPosition[OverlayPosition["TopLeft"] = 2] = "TopLeft";
    OverlayPosition[OverlayPosition["TopCenter"] = 3] = "TopCenter";
    OverlayPosition[OverlayPosition["TopRight"] = 4] = "TopRight";
    OverlayPosition[OverlayPosition["BottomLeft"] = 5] = "BottomLeft";
    OverlayPosition[OverlayPosition["BottomCenter"] = 6] = "BottomCenter";
    OverlayPosition[OverlayPosition["BottomRight"] = 7] = "BottomRight";
})(OverlayPosition || (OverlayPosition = {}));
